import { createReducer } from "@reduxjs/toolkit";
import { resetRetrieveTeacherStudio, retrieveTeacherStudio } from "./retrieve-teacher-studio";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherStudioListItem } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<TeacherStudioListItem | null> = {
  fetching: "idle",
  data: null,
};

export const retrieveTeacherStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveTeacherStudio.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveTeacherStudio.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveTeacherStudio.rejected, state => {
      state.fetching = "failed";
    })
    .addCase(resetRetrieveTeacherStudio, () => {
      return initialState;
    });
});
